<template>
  <div class="container">
    <h1>Send SMS: Preview</h1>
    <div class="row">
      <div class="col">
        <div class="sms-container">
          <h5 class="sms-container-header">
            <strong>{{ this.phoneNumber }}</strong>
          </h5>

          <p name="labelSmsText" v-html="smsText" class="sms-preview"></p>
        </div>

        <div class="sms-container-footer">
          <h5>
            <strong name="labelTime">{{ time }}</strong>
          </h5>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <h6>SMS</h6>
        <p v-if="showEncoding">{{ parts.length }}</p>
      </div>
      <div class="col-lg-4">
        <h6>Encoding</h6>
        <p v-if="showEncoding">{{ encoding }}</p>
      </div>
      <div class="col-lg-3" v-if="envService.featureToggleSmsTag()">
        <h6>Tags</h6>
        <p>
          <span v-for="tagEntry in tags" :key="tagEntry"><span class="sms-tag">{{ tagEntry }}</span>&nbsp;</span>
        </p>
      </div>
    </div>
    <br/>
    <div class="row">
      <div class="col">
        <sdx-button-group class="align-left">
          <sdx-dialog-toggle>
            <sdx-button
                id="buttonSend"
                label="Send"
                @click="sendSms()">
            </sdx-button>
          </sdx-dialog-toggle>
          <sdx-dialog-content class="text-align-center">
            <sdx-dialog
                class="text-align-2"
                notification-type="confirmation validation"
                icon-name="icon-check-mark-2-circle"
                label="Done!"
                type="closable-modal"
                ref="successDialog"
            >
              <sdx-dialog-content>
                <p class="text-align-center">Your SMS has been sent successfully!</p>
                <sdx-button-group layout="responsive-fill">
                  <sdx-button label="Close" @click="goToStartPage()"/>
                </sdx-button-group>
              </sdx-dialog-content>
            </sdx-dialog>
            <sdx-dialog
                class="margin-1"
                notification-type="warning"
                icon-name="icon icon-cancel"
                label="Error!"
                type="closable-modal"
                ref="errorDialog">
              <sdx-dialog-content>
                <p class="text-align-center">Please check your informations.</p>
                <sdx-button-group layout="responsive-fill">
                  <sdx-button label="Close" @click="goToStartPage()"/>
                </sdx-button-group>
              </sdx-dialog-content>
            </sdx-dialog>
          </sdx-dialog-content>
          <sdx-button id="buttonBack" theme="secondary" label="Back" @click="goToStartPage()"/>
        </sdx-button-group>
      </div>
    </div>
  </div>
</template>

<script>
import {postSendSms} from "@/modules/sendsms/service";
import unicodeDetectorService from '../../unicodeDetector/service'
import envService from "@/services/env.service";
import {logger} from "@/services/logger.service";
import {showAlert} from "@/services/notification.service";

export default {
  data() {
    return {
      time: new Date().getHours().toString().padStart(2, '0') + ':' + new Date().getMinutes().toString().padStart(2, '0'),
      devAppWebId: '',
      devAppSmsTitle: [],
      phoneNumber: '',
      smsText: '',
      tag: '',
      tags: [],
      parts: [],
      encoding: '',
      showEncoding: false,
    };
  },
  mounted() {
    this.devAppWebId = sessionStorage.getItem(`sendSmsWebId`);
    this.phoneNumber = sessionStorage.getItem(`phoneNumber`);
    this.smsText = sessionStorage.getItem(`smsText`);
    this.tag = sessionStorage.getItem('tag');
    logger.debug("tag:" + this.tag)
    if (this.tag && this.tag!='null') {
      this.tags = this.tag.split(',');
    }
    logger.debug("tags:" + JSON.stringify(this.tags))
    this.getEncodingSms(this.smsText);
  },
  methods: {
    async sendSms() {
      let result;
      try {
        result = await postSendSms(this.devAppWebId, this.phoneNumber, this.smsText, this.tags);
      }catch(ex){
        logger.error(ex)
        showAlert(ex.message)
      }
      if (result!==undefined && result.status === 200 && result.data.success === true) {
        this.$refs.successDialog.open();
      } else {
        this.$refs.errorDialog.open();
      }
    },
    async getEncodingSms(sms) {
      let response = await unicodeDetectorService.splitSms(sms);
      this.parts = response.data.parts;
      this.encoding = response.data.encoding;
      this.showEncoding = true
    },
    goToStartPage() {
      this.$router.push('/sendsms')
    },
    goToModalSended() {
      this.sendSms();
      sessionStorage.removeItem('smsText');
      sessionStorage.removeItem('phoneNumber');
      sessionStorage.removeItem('tag');
    },
  },
  computed: {
    envService() {
      return envService
    }
  }
};
</script>

<style scoped>


</style>
